import { render, staticRenderFns } from "./BuyTab2.vue?vue&type=template&id=3b979c32&scoped=true&lang=pug&"
import script from "./BuyTab2.vue?vue&type=script&lang=js&"
export * from "./BuyTab2.vue?vue&type=script&lang=js&"
import style0 from "./BuyTab2.vue?vue&type=style&index=0&id=3b979c32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b979c32",
  null
  
)

export default component.exports